import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  templateUrl: './park-schedules.html',
  selector: 'park-schedules'
})
export class ParkSchedulesComponent implements OnInit, OnDestroy {
  @Input() schedules: any;
  @Input() park: any;
  objectKeys = Object.keys;

  public sortedSchedules = [];
  private interval;

  constructor (public ngxSmartModalService: NgxSmartModalService) {

  }

  ngOnInit() {
    this.sortSchedules();

    this.interval = setInterval(() => {
      this.sortSchedules();
      this.updateSchedules();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  public updateSchedules() {
    Object.keys(this.schedules).forEach((scheduleId) => {
      const schedule = this.schedules[scheduleId];

      this.sortedSchedules.forEach((sch) => {
        if (scheduleId === sch[0]) {
          sch[1] = schedule;
        }
      });
    });
  }

  public sortSchedules() {
    this.sortedSchedules = [];

    Object.keys(this.schedules).forEach((scheduleId) => {
      const schedule = this.schedules[scheduleId];

      if (schedule.hasOwnProperty('begin')) {
        this.sortedSchedules.push([scheduleId, schedule, parseInt(schedule.begin || 0, 10)]);
      }
    });

    // sort by sort order, then by name
    this.sortedSchedules.sort((a, b) => {
      return a[2] - b[2];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/schedules/park-schedules.component.ts